<script lang="ts">
	import type { ComponentType } from '@wiseed/wikit';
	import ProjectHeaderInfo from '../elements/ProjectHeaderInfo.svelte';
	import { t } from 'svelte-i18n';
	import { capitalize, formatAmountWithCurrency, getYearsBetween } from '@wiseed/wikit';
	import {
		createFinancialInstrumentHeaderComponent,
		getTaxExemptionString,
		isGoalAmountReachedFn,
		isMinAmountReachedFn
	} from '@app/utils/operations';
	import type { OperationModel } from '@app/models/api/OperationModel';
	import ProjectHeader from '../ProjectHeader.svelte';
	import { OperationStatusEnum } from '@app/models/api/enums/OperationStatusEnum';
	import { SVG } from '@wiseed/wikit';
	import { page } from '$app/stores';

	export let operation: OperationModel;
	let isMinAmountReached = isMinAmountReachedFn(operation);
	let isGoalAmountReached = isGoalAmountReachedFn(operation);
	let headerComponents: ComponentType[] = [];

	!operation.status?.includes(OperationStatusEnum.VOTE) &&
		(headerComponents = [
			{
				component: ProjectHeaderInfo,
				props: {
					label: isGoalAmountReached
						? ''
						: isMinAmountReached
							? $t('operation.headers.minAmountReached')
							: $t('operation.headers.objectives'),
					value: isGoalAmountReached
						? $t('operation.headers.goalAmountReached')
						: formatAmountWithCurrency(operation.amountNeededMin),
					classNames: isMinAmountReached || isGoalAmountReached ? 'text-success' : ''
				}
			},
			{
				component: ProjectHeaderInfo,
				props: {
					label: $t('operation.headers.annualInterest'),
					value: $page.data?.user
						? operation.percentAnnualPerformanceMinES && operation.percentAnnualPerformanceMaxES
							? capitalize(
									`Entre ${operation.percentAnnualPerformanceMinES} et ${operation.percentAnnualPerformanceMaxES}% annuel`
								)
							: $t('companyTypeDetail.INCONNU')
						: {
								component: SVG,
								props: {
									name: 'lock',
									classNames: 'text-primary',
									tooltip: {
										content: capitalize($t('needLoginShort'))
									}
								}
							}
				}
			},
			createFinancialInstrumentHeaderComponent(operation),

			{
				component: ProjectHeaderInfo,
				props: operation.primeRemboursementPrevisionnelleTp
					? {
							label: $t('operation.headers.reimbursementBonus'),
							value: capitalize(`${operation.primeRemboursementPrevisionnelleTp}%`)
						}
					: {
							label: $t('operation.headers.taxExemption.label'),
							value: $page?.data?.user
								? getTaxExemptionString(operation)
								: {
										component: SVG,
										props: {
											name: 'lock',
											classNames: 'text-primary',
											tooltip: {
												content: capitalize($t('needLoginShort'))
											}
										}
									}
						}
			},

			{
				component: ProjectHeaderInfo,
				props: {
					label: $t('operation.headers.outingsHorizon'),
					value: `${getYearsBetween(
						operation.dateFinPrevueInteretsTP,
						operation.dateDebutInteretsTP
					)} ans`
				}
			}
		]);
</script>

<ProjectHeader components={headerComponents} />
